export default __webpack_public_path__ + "static/media/x.9b88e4d8.svg";